module.exports = __webpack_public_path__ + "img/10.f99818dc.jpg";